export enum ValidatorsErrorEnum {
    REQUIRED = 'required',
    INVALID_NUMBER = 'invalidNumber',
    MAX_LENGTH = 'maxlength',
    INVALID_TIME = 'invalidTime',
    EQUAL = 'equal',
}
